import CommonHeader from '../pages/Head'
import React from 'react'
import PaydayStatus from '../pages/paydayStatus'
import PaydayCancel from '../pages/paydayCancel'
import PaydayAgreement from '../pages/paydayAgreement'
import ChangePWD from '../pages/changepassword'
import axios from 'axios'

class PaydayLoans extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {adminjobs:'',LID:localStorage.getItem('tokens'), Names:'', CompName:''};				
		this.handleChange=this.handleChange.bind(this)
	}
	
	componentDidMount() {		
		const para={LID:this.state.LID}
		axios.post(process.env.REACT_APP_API_ENV+'api/userinformation.php',para)
			.then(result => {						
				this.setState({Names:result.data[1]})											
			})		
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	
	handleChange = event => {	
		const {name, value} = event.target				
		this.setState({[name]: value})		
	}
	
	render() {							
		return (
			<div id="content">			
				<CommonHeader titles="Payday Loan"/>
				<h2 style={{textAlign:'center'}}>{this.state.CompName + ' welcome ' + this.state.Names}</h2>			
				<div style={{textAlign:'center'}}>
				<h3 style={{textAlign:'center'}}>Manage Payday Loan</h3>
					<select name="adminjobs" id="adminjobs" style={{width: '150px',border:'1px solid #4195fc'}} value={this.state.adminjobs} onChange={this.handleChange}>
						<option value="">--Manage Items--</option>						
						<option value="1">Payday Loan Status</option>						
						<option value="2">Cancel Payday Loan</option>
						<option value="3">Payday Loan Agreement</option>
						<option value="4">Change PWD</option>			
					</select><br/><br/>				
				{(()=>{
					if(this.state.adminjobs === "1") {return (
						<PaydayStatus/>					
					)} else if(this.state.adminjobs === "2") {return (
						<PaydayCancel/>					
					)} else if(this.state.adminjobs === "3") {return (
						<PaydayAgreement/>					
					)} else if(this.state.adminjobs === "4") {return (
						<ChangePWD />					
					)} 
				})()}				
				</div>
			</div>
		)
	}
}

export default PaydayLoans;